var React = require('react');

function SignalAltSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 364V32a32 32 0 0 1 32-32h32a32 32 0 0 1 32 32v406.14zm-64-49.47V160a32 32 0 0 0-32-32h-32a32 32 0 0 0-32 32v80.28zM96 384H64a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm96-96v192a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V352.6l-94.33-72.9c-.74 2.71-1.67 5.36-1.67 8.3zm160 192a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32v-3.73l-96-74.2z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.64 480.55L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45z","className":"fa-primary","key":2})]);
}

SignalAltSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = SignalAltSlash;

SignalAltSlash.default = SignalAltSlash;
